import React from 'react';
import { ChevronRight, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Certification = () => {
  const navigate = useNavigate();
  
  const menuItems = [
    { id: 1, title: 'TV Daily Report', route: '/tv-daily-report' },
    { id: 2, title: 'Monitor Control Table', route: '/monitor-control-table' },
    { id: 3, title: 'AVA Control Table', route: '/ava-control-table' }
  ];

  const handleNavigation = (item) => {
    console.log(`Navigating to: ${item.title}`);
    navigate(item.route);
  };

  const handleBackClick = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="flex items-center p-4 bg-black">
        <button 
          className="text-white"
          onClick={handleBackClick}
        >
          <ArrowLeft size={24} />
        </button>
        <h1 className="flex-1 text-center text-lg font-medium">
          Certification
        </h1>
        <div className="w-6"></div> 
      </header>

      {/* Menu Items */}
      <div className="px-3 pt-4 space-y-3">
        {menuItems.map((item) => (
          <button
            key={item.id}
            onClick={() => handleNavigation(item)}
            className="w-full flex items-center justify-between bg-slate-800 hover:bg-slate-700 
                       transition-colors rounded-lg px-5 py-4 text-left"
          >
            <span className="text-white text-base">{item.title}</span>
            <ChevronRight size={20} className="text-gray-400" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default Certification;
